import { ClientUser } from '@sondermind/utilities/models-user-client';

/**
 * A client with a non-deleted payment card who still owes the Financial Responsibility Agreement:
 * either they have never signed one, or an unsigned one is outstanding alongside a signed one
 * (`requiresFinancialAgreement`). `requiresFinancialAgreement` alone isn't enough: it is false for
 * clients whose insurance doesn't require a card, though account completion still blocks on their
 * unsigned agreement.
 */
export function needsFinancialAgreement(user: ClientUser | null | undefined): boolean {
  if (!user?.hasCreditCard) {
    return false;
  }
  return !user.hasSignedFinancialAgreement || !!user.requiresFinancialAgreement;
}
